import DemoQuikTripClient from "./DemoQuikTripClient";
import QuikTripClient from "./QuikTripClient";

const client =
	localStorage.getItem("demoMode") === "true"
		? new DemoQuikTripClient()
		: new QuikTripClient("https://ema.quiktrip.com/api");
export default client;
